/* =========================================================
   EASYCODSELL - PHONE VERIFY + DUPLICATE ORDER CHECK
   Storage: localStorage (key: easycodsell_orders)
   Robust: works on dynamic DOM (PageFly/modal) via delegation
   ========================================================= */

// === CONFIGURAZIONE ===
const DUPLICATE_CHECK_HOURS = 24;
const STORAGE_KEY = 'easycodsell_orders';
const KEEP_HOURS = 48;

// === VARIABILI GLOBALI ===
window.allowSubmit = false;
window.pendingOrder = null;
window.phoneVerified = false;

// =========================================================
// STORAGE (localStorage)
// =========================================================
function getSavedOrders() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const orders = raw ? JSON.parse(raw) : [];

    // Pulisci ordini vecchi oltre KEEP_HOURS
    const cutoff = Date.now() - (KEEP_HOURS * 60 * 60 * 1000);
    const recent = Array.isArray(orders) ? orders.filter(o => o && o.timestamp > cutoff) : [];

    if (!Array.isArray(orders) || recent.length !== orders.length) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
    }

    return recent;
  } catch (e) {
    console.log('📝 Nessun ordine salvato o errore nel recupero:', e);
    return [];
  }
}

function saveOrder(orderData) {
  try {
    if (!orderData?.customerName || orderData.customerName.length < 2) {
      console.log('📝 Nome mancante o troppo corto, skip salvataggio');
      return null;
    }
    if (!orderData?.phone || String(orderData.phone).replace(/\D/g, '').length < 5) {
      console.log('📝 Telefono mancante o troppo corto, skip salvataggio');
      return null;
    }

    const orders = getSavedOrders();
    orders.push({
      ...orderData,
      timestamp: Date.now(),
      id: Date.now() + Math.random()
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(orders));
    console.log('💾 Ordine salvato:', orderData);
    return true;
  } catch (e) {
    console.error('❌ Errore nel salvataggio ordine:', e);
    return null;
  }
}

function checkForDuplicate(newOrderData) {
  if (!newOrderData?.customerName || newOrderData.customerName.length < 2) {
    console.log('📝 Nome mancante o troppo corto, skip controllo duplicati');
    return null;
  }
  if (!newOrderData?.phone || String(newOrderData.phone).replace(/\D/g, '').length < 5) {
    console.log('📝 Telefono mancante o troppo corto, skip controllo duplicati');
    return null;
  }

  const orders = getSavedOrders();
  const cutoff = Date.now() - (DUPLICATE_CHECK_HOURS * 60 * 60 * 1000);

  const normalizedNewPhone = String(newOrderData.phone).replace(/\D/g, '');
  const normalizedNewEmail = (newOrderData.email || '').trim().toLowerCase();
  const newProduct = (newOrderData.productName || '').trim();

  return orders.find(order => {
    if (!order || order.timestamp < cutoff) return false;

    const normalizedOrderPhone = String(order.phone || '').replace(/\D/g, '');
    const normalizedOrderEmail = (order.email || '').trim().toLowerCase();
    const orderProduct = (order.productName || '').trim();

    // telefono + prodotto
    if (normalizedOrderPhone && normalizedOrderPhone === normalizedNewPhone && orderProduct === newProduct) {
      return true;
    }

    // email + prodotto (se email presente)
    if (normalizedNewEmail && normalizedOrderEmail === normalizedNewEmail && orderProduct === newProduct) {
      return true;
    }

    return false;
  });
}

// =========================================================
// UTILS telefono
// =========================================================
function sanitizePhoneInput(input) {
  if (!input || typeof input !== 'string') return '';
  return input
    .trim()
    .substring(0, 20)
    .replace(/[<>'"&]/g, '')
    .replace(/[^\d\s\-\(\)+]/g, '');
}

function validatePhoneNumber(phone) {
  const cleanPhone = phone.replace(/[^\d+]/g, '');

  if (!cleanPhone) return { valid: false, error: 'Numero di telefono richiesto' };
  if (cleanPhone.length < 6) return { valid: false, error: 'Numero troppo corto (minimo 6 cifre)' };
  if (cleanPhone.length > 15) return { valid: false, error: 'Numero troppo lungo (massimo 15 cifre)' };

  if (cleanPhone.startsWith('+')) {
    const afterPlus = cleanPhone.substring(1);
    if (!/^\d+$/.test(afterPlus)) return { valid: false, error: 'Formato non valido' };
  } else {
    if (!/^\d+$/.test(cleanPhone)) return { valid: false, error: 'Formato non valido' };
  }

  return { valid: true, cleanPhone };
}

function formatPhoneForDisplay(phone) {
  if (!phone) return 'Non inserito';

  let cleaned = String(phone).replace(/[^\d+]/g, '');

  if (cleaned.startsWith('+39')) {
    const number = cleaned.substring(3);
    if (number.length === 10) return `+39 ${number.substring(0, 3)} ${number.substring(3, 6)} ${number.substring(6)}`;
    return `+39 ${number}`;
  }

  if (cleaned.startsWith('+')) {
    const match = cleaned.match(/^(\+\d{1,3})(\d+)$/);
    if (match) {
      const prefix = match[1];
      const number = match[2];
      const formatted = number.match(/.{1,3}/g)?.join(' ') || number;
      return `${prefix} ${formatted}`;
    }
    return cleaned;
  }

  if (cleaned.length === 10) return `${cleaned.substring(0, 3)} ${cleaned.substring(3, 6)} ${cleaned.substring(6)}`;

  return cleaned.match(/.{1,3}/g)?.join(' ') || cleaned;
}

// =========================================================
// POPUP UI
// =========================================================
function createPopupHTML() {
  return `
  <div id="duplicateWarningOverlay" style="display:none; position:fixed; inset:0; width:100vw; height:100vh; background:rgba(0,0,0,0.8); z-index:2147483647; overflow:hidden;">
    <div style="position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); background:#fff; border-radius:12px; padding:30px; max-width:90%; width:400px; max-height:90vh; overflow-y:auto; box-shadow:0 10px 30px rgba(0,0,0,0.3); text-align:center; font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;">
      <div style="font-size:48px; color:#ff9800; margin-bottom:20px;">⚠️</div>
      <div style="font-size:22px; font-weight:800; color:#333; margin-bottom:15px;">Attenzione! Ordine già effettuato</div>
      <div style="font-size:16px; color:#666; margin-bottom:25px; line-height:1.5;">Sembra che tu abbia già effettuato un ordine simile di recente.<br>Il tuo precedente ordine è stato ricevuto correttamente e sarà processato.</div>

      <div style="background:#f5f5f5; padding:15px; border-radius:8px; margin-bottom:25px; text-align:left;">
        <h4 style="margin:0 0 10px 0; font-size:16px; color:#333; font-weight:800;">Dettagli ordine precedente:</h4>
        <p id="prevOrderTime" style="margin:5px 0; font-size:14px; color:#555;"></p>
        <p id="prevOrderProduct" style="margin:5px 0; font-size:14px; color:#555;"></p>
        <p id="prevOrderPhone" style="margin:5px 0; font-size:14px; color:#555; font-family:'Courier New',monospace;"></p>
      </div>

      <div style="display:flex; flex-wrap:wrap; gap:12px; justify-content:center;">
        <button id="cancelOrderBtn" style="padding:12px 20px; border-radius:6px; font-size:16px; border:none; background:#28a745; color:white; cursor:pointer; font-weight:700; min-width:140px;">Annulla nuovo ordine</button>
        <button id="proceedOrderBtn" style="padding:12px 20px; border-radius:6px; font-size:16px; border:none; background:#dc3545; color:white; cursor:pointer; font-weight:700; min-width:140px;">Procedi comunque</button>
      </div>
    </div>
  </div>

  <div id="phoneVerificationOverlay" style="display:none; position:fixed; inset:0; width:100vw; height:100vh; background:rgba(0,0,0,0.8); z-index:2147483647;">
    <div style="position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); background:#fff; border-radius:12px; padding:30px; width:420px; max-width:90%; text-align:center; font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;">
      <div style="font-size:48px; color:#2196F3; margin-bottom:20px;">📞</div>
      <div style="font-size:22px; font-weight:800; color:#333; margin-bottom:12px;">Verifica il tuo numero</div>
      <div style="font-size:15px; color:#666; margin-bottom:18px; line-height:1.5;">Controlla che il tuo numero sia corretto, così possiamo chiamarti senza problemi</div>

      <div style="background:#f5f5f5; padding:20px; border-radius:8px; margin-bottom:22px;">
        <p style="margin:0 0 10px 0; font-size:13px; color:#888; text-transform:uppercase; letter-spacing:0.5px;">Il tuo numero:</p>
        <p id="currentPhoneDisplay" style="margin:0 0 14px 0; font-size:22px; font-weight:800; color:#333; font-family:'Courier New',monospace; letter-spacing:1px;"></p>

        <div style="margin: 0 0 10px 0; font-size: 14px; color: #555; font-weight: 600;">
            Puoi modificarlo qui sotto:
        </div>
        
        <input type="tel" id="phoneVerificationInput" placeholder="Modifica se necessario" maxlength="20" autocomplete="tel"
        style="
            width:100%;
            padding:18px 16px;
            border:3px solid #ddd;
            border-radius:10px;
            font-size:26px;
            font-weight:800;
            line-height:1.2;
            text-align:center;
            font-family:'Courier New',monospace;
            letter-spacing:2px;
            outline:none;
            box-sizing:border-box;
        ">

        <div id="phoneErrorMessage" style="display:none; margin-top:10px; color:#dc3545; font-size:14px; font-weight:600;"></div>
      </div>

      <div style="display:flex; gap:12px; justify-content:center;">
        <button id="cancelPhoneBtn" style="padding:12px 20px; border:none; background:#6c757d; color:white; border-radius:6px; cursor:pointer; font-size:16px; font-weight:700;">Annulla</button>
        <button id="confirmPhoneBtn" style="padding:12px 24px; border:none; background:#28a745; color:white; border-radius:6px; cursor:pointer; font-size:16px; font-weight:800;">✓ Conferma</button>
      </div>
    </div>
  </div>
  `;
}

function showPhoneError(message) {
  const el = document.getElementById('phoneErrorMessage');
  if (!el) return;
  el.textContent = message;
  el.style.display = 'block';
}

function hidePhoneError() {
  const el = document.getElementById('phoneErrorMessage');
  if (!el) return;
  el.style.display = 'none';
}

function showDuplicateWarning(previousOrder, newOrderData) {
  const overlay = document.getElementById('duplicateWarningOverlay');
  if (!overlay) return;

  const prevTime = new Date(previousOrder.timestamp).toLocaleString('it-IT', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
  });

  document.getElementById('prevOrderTime') && (document.getElementById('prevOrderTime').textContent = `📅 Data: ${prevTime}`);
  document.getElementById('prevOrderProduct') && (document.getElementById('prevOrderProduct').textContent = `📦 Prodotto: ${previousOrder.productName || '-'}`);
  document.getElementById('prevOrderPhone') && (document.getElementById('prevOrderPhone').textContent = `📞 Telefono: ${formatPhoneForDisplay(previousOrder.phone)}`);

  window.pendingOrder = newOrderData;

  overlay.style.display = 'flex';
  overlay.classList.add('show');
}

function hideDuplicateWarning() {
  const overlay = document.getElementById('duplicateWarningOverlay');
  if (!overlay) return;
  overlay.style.display = 'none';
  overlay.classList.remove('show');
}

function showPhoneVerificationPopup(orderData) {
  const overlay = document.getElementById('phoneVerificationOverlay');
  if (!overlay) return;

  const currentPhoneDisplay = document.getElementById('currentPhoneDisplay');
  const phoneInput = document.getElementById('phoneVerificationInput');

  if (currentPhoneDisplay) currentPhoneDisplay.textContent = formatPhoneForDisplay(orderData.phone);
  if (phoneInput) phoneInput.value = orderData.phone || '';

  window.pendingOrder = orderData;
  overlay.style.display = 'flex';

  if (phoneInput) setTimeout(() => phoneInput.focus(), 120);
}

function hidePhoneVerificationPopup() {
  const overlay = document.getElementById('phoneVerificationOverlay');
  if (!overlay) return;
  overlay.style.display = 'none';
  hidePhoneError();
}

// =========================================================
// ESTRAZIONE DATI ORDINE
// =========================================================
function extractOrderData() {
  const productTitleElement = document.querySelector('.es-product-title');
  const productName = productTitleElement ? productTitleElement.textContent.trim() : 'Prodotto';

  const nameInput = document.getElementById('es-last_name');
  const phoneInput = document.getElementById('es-phone');
  const emailInput = document.getElementById('es-email');

  const orderData = {
    productName,
    customerName: nameInput ? nameInput.value.trim() : '',
    // Per confronto/storage usiamo SOLO cifre
    phone: phoneInput ? String(phoneInput.value).replace(/\D/g, '') : '',
    email: emailInput ? emailInput.value.trim() : ''
  };

  console.log('📊 Dati ordine estratti:', orderData);
  return orderData;
}

function isFormValid() {
  const nameInput = document.getElementById('es-last_name');
  const phoneInput = document.getElementById('es-phone');

  const name = nameInput ? nameInput.value.trim() : '';
  const phone = phoneInput ? phoneInput.value.trim() : '';

  if (!name || name.length < 2) return false;
  if (!phone || phone.length < 5) return false;
  return true;
}

// =========================================================
// AZIONI GLOBALI (bottoni popup)
// =========================================================
window.cancelNewOrder = function () {
  hideDuplicateWarning();
  window.pendingOrder = null;
  window.allowSubmit = false;
};

window.cancelPhoneVerification = function () {
  hidePhoneVerificationPopup();
  window.pendingOrder = null;
  window.allowSubmit = false;
  window.phoneVerified = false;
};

window.proceedWithOrder = function () {
  hideDuplicateWarning();
  if (window.pendingOrder) {
    saveOrder(window.pendingOrder);
    window.allowSubmit = true;
    setTimeout(() => document.getElementById('es-form-button')?.click(), 80);
    window.pendingOrder = null;
  }
};

// =========================================================
// CONFERMA NUMERO (continua con duplicati + salvataggio)
// =========================================================
window.confirmPhoneNumber = function () {
  try {
    hidePhoneError();

    const phoneInput = document.getElementById('phoneVerificationInput');
    if (!phoneInput) return false;

    const rawPhoneValue = phoneInput.value || '';
    const sanitizedPhone = sanitizePhoneInput(rawPhoneValue);

    const validation = validatePhoneNumber(sanitizedPhone);
    if (!validation.valid) {
      showPhoneError(validation.error);
      return false;
    }

    const validatedPhone = validation.cleanPhone;

    // Aggiorna campo originale (manteniamo + eventuale, ma in pendingOrder salviamo solo cifre)
    const originalPhoneInput = document.getElementById('es-phone');
    if (originalPhoneInput) {
      originalPhoneInput.value = validatedPhone;
      try {
        originalPhoneInput.dispatchEvent(new Event('input', { bubbles: true }));
        originalPhoneInput.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (_) {}
    }

    if (window.pendingOrder && typeof window.pendingOrder === 'object') {
      window.pendingOrder.phone = validatedPhone.replace(/\D/g, '');
    }

    window.phoneVerified = true;
    hidePhoneVerificationPopup();

    // Controllo duplicati + salvataggio
    if (window.pendingOrder) {
      const duplicate = checkForDuplicate(window.pendingOrder);
      if (duplicate) {
        showDuplicateWarning(duplicate, window.pendingOrder);
      } else {
        saveOrder(window.pendingOrder);
        window.allowSubmit = true;
        setTimeout(() => document.getElementById('es-form-button')?.click(), 80);
        window.pendingOrder = null;
      }
    }

    return true;
  } catch (e) {
    console.error('❌ Errore in confirmPhoneNumber:', e);
    showPhoneError('Errore durante la validazione. Riprova.');
    return false;
  }
};

// =========================================================
// INTERCETTAZIONE CLICK (delegation robusto)
// =========================================================
function isEasyCodSellSubmitTarget(target) {
  if (!target) return false;
  if (target.id === 'es-form-button') return true;
  const closest = target.closest && target.closest('#es-form-button');
  return !!closest;
}

function installDelegatedInterceptorOnce() {
  if (document.documentElement.dataset.esDupDelegated === 'true') return;
  document.documentElement.dataset.esDupDelegated = 'true';

  document.addEventListener(
    'click',
    function (e) {
      if (!isEasyCodSellSubmitTarget(e.target)) return;

      console.log('🔘 Click INVIA ORDINE intercettato (delegated)');

      // se autorizzato, lascia passare
      if (window.allowSubmit) {
        window.allowSubmit = false;
        return;
      }

      // blocca e gestisce noi
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!isFormValid()) {
        console.log('❌ Form non valido, lascio gestire a EasyCodSell');
        window.allowSubmit = true;
        setTimeout(() => document.getElementById('es-form-button')?.click(), 60);
        return;
      }

      const orderData = extractOrderData();

      // sempre verifica telefono prima
      if (!window.phoneVerified) {
        showPhoneVerificationPopup(orderData);
        return;
      }

      // se già verificato (es. utente riapre modal e riprova), controlla duplicati qui
      const duplicate = checkForDuplicate(orderData);
      if (duplicate) {
        showDuplicateWarning(duplicate, orderData);
      } else {
        saveOrder(orderData);
        window.allowSubmit = true;
        setTimeout(() => document.getElementById('es-form-button')?.click(), 80);
      }
    },
    true
  );
}

// =========================================================
// INIT
// =========================================================
function ensurePopupsExist() {
  if (!document.getElementById('duplicateWarningOverlay')) {
    document.documentElement.insertAdjacentHTML('beforeend', createPopupHTML());
  }

  // Bind bottoni popup (idempotente: rimuove vecchi listener clonando)
  const idsToRebind = [
    ['cancelOrderBtn', 'click', window.cancelNewOrder],
    ['proceedOrderBtn', 'click', window.proceedWithOrder],
    ['confirmPhoneBtn', 'click', window.confirmPhoneNumber],
    ['cancelPhoneBtn', 'click', window.cancelPhoneVerification],
  ];

  for (const [id, evt, fn] of idsToRebind) {
    const el = document.getElementById(id);
    if (!el) continue;
    const clone = el.cloneNode(true);
    el.replaceWith(clone);
    document.getElementById(id)?.addEventListener(evt, fn);
  }

  const phoneInput = document.getElementById('phoneVerificationInput');
  if (phoneInput) {
    const clone = phoneInput.cloneNode(true);
    phoneInput.replaceWith(clone);
    const fresh = document.getElementById('phoneVerificationInput');
    fresh?.addEventListener('input', hidePhoneError);
    fresh?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        window.confirmPhoneNumber();
      }
    });
  }
}

function initializeDuplicateChecker() {
  try {
    ensurePopupsExist();
    installDelegatedInterceptorOnce();
  } catch (e) {
    console.error('❌ initializeDuplicateChecker error:', e);
  }
}

// Boot (copre PageFly / instant-page / contenuti dinamici)
(function boot() {
  const run = () => initializeDuplicateChecker();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('pageshow', () => setTimeout(run, 50));
  setTimeout(run, 500);
  setTimeout(run, 1500);

  // Observer: se compare modal o bottone dopo, reinizializza UI
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes || []) {
        if (node.nodeType !== 1) continue;
        if (
          node.id === 'es-form-button' ||
          node.querySelector?.('#es-form-button') ||
          node.id === 'easysell-modal' ||
          node.querySelector?.('#easysell-modal')
        ) {
          setTimeout(run, 50);
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Debug helper
  window.debugDuplicateCheck = function () {
    console.log('🔧 DEBUG: Test manuale controllo duplicati');
    const orderData = extractOrderData();
    const dup = checkForDuplicate(orderData);
    console.log('OrderData:', orderData);
    console.log('Duplicate:', dup);
    console.log('Saved orders count:', getSavedOrders().length);
    if (dup) showDuplicateWarning(dup, orderData);
    else {
      saveOrder(orderData);
      console.log('Ordine di test salvato');
    }
  };

  console.log('🎯 Duplicate checker loaded. Storage key:', STORAGE_KEY);
})();
